import React from "react";
import styled from "styled-components";
const StylableAudio = React.forwardRef((props, ref) => {
    const { media, ...rest } = props;
    return (React.createElement("audio", { ...rest, ref: ref }, media.sources.map((source, index) => (React.createElement("source", { "data-testid": `source-${source.type}`, key: index, src: source.src, type: source.type })))));
});
StylableAudio.displayName = "StylableAudio";
StylableAudio.defaultProps = {
    "data-testid": "mediaAudio",
};
export const MediaAudio = styled(StylableAudio) ``;
//# sourceMappingURL=MediaAudio.js.map